import { render, staticRenderFns } from "./ContestEntryDataDialog.vue?vue&type=template&id=ef508a74&scoped=true"
import script from "./ContestEntryDataDialog.vue?vue&type=script&lang=ts"
export * from "./ContestEntryDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryDataDialog.vue?vue&type=style&index=0&id=ef508a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef508a74",
  null
  
)

export default component.exports